import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const RedDot: React.FC<NormalIconProps> = (props) => (
	<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg" className={props.className}>
		<rect width="8" height="8" rx="4" fill="#EE1313" />
	</svg>
);
